import { SurveyPostAnswerMetaSvend } from '@surveycake/logic-engine';
import { PageModule } from 'app/pages/types';
import React from 'react';
import Ending from './Ending';

export const EndingPageModule: PageModule = {
  pageIf: (page, exception) =>
    !exception && (page === 'thankyou' || page === 'ended' || page === 'sorry'),
  render: page => <Ending type={page as SurveyPostAnswerMetaSvend} />
};
